import { SET_RELOAD_ALL_REVIEWS, SetReloadAllReviews } from './types';

export const setReloadAllReviews = (payload: boolean): SetReloadAllReviews => ({
  type: SET_RELOAD_ALL_REVIEWS,
  payload,
});
